import React, { useEffect } from 'react';
import Layout from '../../components/Layout';
import {Link} from "react-router-dom";
import {ReportsIcon, DeleteIcon, FilterIcon, EyeOpen, EditIcon} from "../../assets/icons/Icons";
import { FilterContextProvider } from "../../contexts/FilterContext";
import CreateReportForm from "../../components/report/Create";
import Chip from "../../components/Chip";
import MessagePopup from "../../components/MessagePopup";
import DataTable from "../../components/DataTable";
import useData from "../../hooks/useData";
import DropdownButton from "../../components/DropdownButton";
import RadioFilter from "../../components/filters/RadioFilter";
import { DeleteReport } from "../../api/reports/deleteReport";
import FilterReports from "../../api/reports/filterReports";
import ConfirmModal from "../../components/ConfirmModal";
import EditReportForm from "../../components/report/Edit";
import ResetFilters from "../../components/filters/ResetFilters";
import {useTranslation} from "react-i18next";
import SelectFilter from "../../components/filters/SelectFilter";
import CustomTooltip from "../../components/CustomTooltip";
import { useGlobalContext } from '../../contexts/GlobalContext';

function Index(props) {

    const { t } = useTranslation();

    const {
        data,
        errorMessage,
        loadingData,
        pageCount,
        selectedItem,
        setSelectedItem,
        newItemAdded,
        setNewItemAdded,
        showCreateItem,
        setShowCreateItem,
        showEditItem,
        setShowEditItem,
        itemUpdated,
        setItemUpdated,
        showDeleteItem,
        setShowDeleteItem,
        selectedForDelete,
        setSelectedForDelete,
        deleteItem
    } = useData(FilterReports, DeleteReport);

        const { setPageTitle, setBreadcrumbs } = useGlobalContext();
          
        useEffect(() => {
            setPageTitle(t("Reports"));
            setBreadcrumbs([t("Reports"), t("Reporting Subscription")]);
          
            return () => {
              setPageTitle("");
              setBreadcrumbs([]);
            };
              // eslint-disable-next-line
        }, []);

    return (
        <Layout title={t("Reporting Subscription")} breadcrumbs={t("Reports")}>

            {showDeleteItem && <ConfirmModal title={t("Report with ID ") + selectedForDelete + t(' will be deleted')} question={t("Please confirm report deletion")} onClose={e => {setShowDeleteItem(false); setSelectedForDelete(null)}} onConfirm={deleteItem}/>}
            {showCreateItem && <CreateReportForm onClose={() => setShowCreateItem(false)} onCreate={e => {setShowCreateItem(false); setNewItemAdded(true); }} />}
            {newItemAdded && <MessagePopup title={t("Report Form Submitted!")} message={t("The report has been successfully created!")} onClose={e => setNewItemAdded(false)}/>}
            {showEditItem && <EditReportForm reportSubscription={ selectedItem } onClose={() => setShowEditItem(false)} onUpdate={e => {setShowEditItem(false); setItemUpdated(true); }} />}
            {itemUpdated && <MessagePopup title={t("Report Updated!")} message={t("The report has been successfully updated!")} onClose={e => setItemUpdated(false)}/>}

            <DataTable
                filtersTop={<>
                    <FilterContextProvider name="status">
                        <SelectFilter options={[
                            {
                                value: 'active',
                                label: t('Active')
                            },
                            {
                                value: 'inactive',
                                label: t('Inactive')
                            }
                        ]}  placeholder={<div>{t("Status")}</div>}/>
                    </FilterContextProvider>
                    <FilterContextProvider>
                        <ResetFilters/>
                    </FilterContextProvider>
                </>}
                buttons={<>
                    <button className="btn btn-primary btn-medium ml-3" onClick={e => setShowCreateItem(true)}>
                        {t("Create")}
                    </button>
                </>}
                columns={[
                    { header: t("ID"), accessor: "id" },
                    { header: t("Report"), accessor: "report" },
                    { header: t("Email"), accessor: "email" },
                    { header: t("Frequency"), accessor: "frequency" },
                    { header: t("Time range"), accessor: "time_range" },
                    { header: t("Last run"), accessor: "last_run_time" },
                    { header: t("Delivery method"), accessor: "reporting_method" },
                    { header: t("Status"), accessor: "is_active" },
                    { header: t("Action"), accessor: "actions" }
                ]}
                rows={data.data || []}
                pageCount={pageCount}
                loadingData={loadingData}
                error={errorMessage}
                emptyDataMessage={t("No reports found")}
                actions={(item) => (
                    <div className="d-flex align-items-center">
                        <Link to="#" className="mr-1 link-with-icon" onClick={e => { e.preventDefault(); setSelectedItem(item); setShowEditItem(true) }}>
                            <CustomTooltip icon={<EditIcon/>} message={t('View')}/>
                        </Link>
                        <Link to="#" className="link-with-icon remove-link" onClick={e => { e.preventDefault(); setSelectedForDelete(item.id); setShowDeleteItem(true) }}>
                            <CustomTooltip icon={<DeleteIcon/>} message={t("Delete")}/>
                        </Link>
                    </div>
                )}
                customOutputs={(columnName, value) => {
                    switch (columnName){
                        case 'is_active' :
                            let status = 'inactive';
                            if(value){
                                status = 'active';
                            }
                            return <Chip state={status} label={status.charAt(0).toUpperCase() + status.slice(1)} showAsTooltop/>
                       case 'frequency' :
                            return value.slice(1).charAt(0).toUpperCase() + value.slice(2);
                       case 'time_range' :
                       case 'reporting_method' :
                            return value.charAt(0).toUpperCase() + value.slice(1);
                       case 'report' :

                               let str = value
                                   .split('_')
                                   .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                   .join(' ');

                               return str.trim();
                        default:
                            return value
                    }
                }}
            />

        </Layout>
    );
}

export default Index;